const debugStorageKey = 'skf-widget-debug-console-enabled';

export function isWidgetDebugConsoleEnabled(): boolean {
    if (typeof window === 'undefined' || !window.localStorage) {
        return false;
    }

    try {
        return window.localStorage.getItem(debugStorageKey) === 'true';
    } catch {
        return false;
    }
}

export function setWidgetDebugConsoleEnabled(enabled: boolean): void {
    if (typeof window === 'undefined' || !window.localStorage) {
        return;
    }

    try {
        window.localStorage.setItem(debugStorageKey, enabled ? 'true' : 'false');
    } catch {
        // ignore storage failures for debug preference
    }
}
